<template>
  <div class="p-3">
    <!-- Header -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
      <div class="d-flex align-items-center gap-2">
        <!-- <button class="btn btn-sm btn-outline-secondary" @click="$router.push({ name: 'reports' })">
          <i class="fa-solid fa-arrow-left me-1"></i>{{ $t('Back') }}
        </button> -->
        <div>
          <h5 class="fw-bold mb-0">
            <i class="fa-solid fa-triangle-exclamation me-2" style="color: #f59e0b;"></i>{{ $t('Low Stock Alert') }}
          </h5>
          <small class="text-muted">{{ $t('Inventory & Stock') }}</small>
        </div>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary btn-sm" @click="downloadPdf" :disabled="pdfLoading">
          <i class="fa-solid fa-download me-1"></i>{{ $t('Download') }}
        </button>
        <button class="btn btn-primary btn-sm" @click="previewPdf" :disabled="pdfLoading">
          <span v-if="pdfLoading"><i class="fa-solid fa-spinner fa-spin me-1"></i>{{ $t('Generating') }}...</span>
          <span v-else><i class="fa-solid fa-file-pdf me-1"></i>{{ $t('Preview PDF') }}</span>
        </button>
      </div>
    </div>

    <!-- Filters -->
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body py-2 px-3">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <select v-model="filters.branch" class="form-select form-select-sm" style="min-width: 140px; max-width: 200px;">
            <option value="all">{{ $t('All Branches') }}</option>
            <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
          </select>
          <input type="date" v-model="filters.dateFrom" class="form-control form-control-sm" style="width: 145px;" />
          <span class="text-muted small">—</span>
          <input type="date" v-model="filters.dateTo" class="form-control form-control-sm" style="width: 145px;" />
          <button class="btn btn-sm btn-primary" @click="applyFilters">
            <i class="fa-solid fa-magnifying-glass me-1"></i>{{ $t('Apply') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Report Content -->
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-header bg-white border-0 py-3">
        <h6 class="mb-0 fw-semibold"><i class="fa-solid fa-triangle-exclamation me-2 text-warning"></i>{{ $t('Low Stock Items') }}</h6>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover table-sm mb-0 align-middle">
            <thead class="table-light">
              <tr>
                <th class="ps-3">{{ $t('Item') }}</th>
                <th class="text-end">{{ $t('Current Stock') }}</th>
                <th class="text-end">{{ $t('Min Level') }}</th>
                <th class="text-end pe-3">{{ $t('Status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in lowStockData" :key="s.item">
                <td class="ps-3 fw-medium">{{ s.item }}</td>
                <td class="text-end">{{ s.current }} {{ s.unit }}</td>
                <td class="text-end text-muted">{{ s.minLevel }} {{ s.unit }}</td>
                <td class="text-end pe-3">
                  <span class="badge" :class="s.current <= 0 ? 'bg-danger' : s.current <= s.minLevel ? 'bg-warning text-dark' : 'bg-success'">
                    {{ s.current <= 0 ? $t('Out of Stock') : s.current <= s.minLevel ? $t('Low') : $t('OK') }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportMixin from './reportMixin';

export default {
  name: 'ReportLowStock',
  mixins: [reportMixin],
  data() {
    return {
      reportLabel: 'Low Stock Alert',
    };
  },
  methods: {
    async buildPdfDefinition() {
      const content = [
        ...this.buildPdfHeader(),
        { text: this.$t('Low Stock Items'), style: 'sectionTitle' },
        {
          table: {
            headerRows: 1,
            widths: ['*', 'auto', 'auto', 'auto'],
            body: [
              [
                { text: this.$t('Item'), style: 'tableHeader' },
                { text: this.$t('Current Stock'), style: 'tableHeader', alignment: 'right' },
                { text: this.$t('Min Level'), style: 'tableHeader', alignment: 'right' },
                { text: this.$t('Status'), style: 'tableHeader', alignment: 'right' },
              ],
              ...this.lowStockData.map(s => [
                { text: s.item, style: 'tableCell' },
                { text: `${s.current} ${s.unit}`, style: 'tableCell', alignment: 'right' },
                { text: `${s.minLevel} ${s.unit}`, style: 'tableCell', alignment: 'right' },
                { text: s.current <= 0 ? this.$t('Out of Stock') : s.current <= s.minLevel ? this.$t('Low') : this.$t('OK'), style: 'tableCell', alignment: 'right', color: s.current <= 0 ? '#ef4444' : s.current <= s.minLevel ? '#f59e0b' : '#22c55e' },
              ]),
            ],
          },
          layout: 'lightHorizontalLines',
        },
      ];
      return { content };
    },
  },
  computed: {
    lowStockData() {
      return [
        { item: 'กุ้งสด',     unit: 'kg', current: 5, minLevel: 15 },
        { item: 'เส้นผัดไทย', unit: 'kg', current: 3, minLevel: 10 },
        { item: 'นม',         unit: 'L',  current: 4, minLevel: 10 },
        { item: 'มะนาว',      unit: 'kg', current: 2, minLevel: 8 },
        { item: 'พริกแห้ง',   unit: 'kg', current: 0, minLevel: 3 },
        { item: 'น้ำปลา',     unit: 'L',  current: 8, minLevel: 5 },
      ];
    },
  },
};
</script>

